import create from 'zustand';

interface ICatalogueState {
    activeProducts: boolean;
    activeProduct: boolean | null;
    checked: boolean;
    listOfCheckedProducts: number[];
    showPricingForm: boolean;
    setActiveProducts: (state: boolean) => void;
    setActiveProduct: (state: boolean) => void;
    setListOfCheckedProducts: (list: number[]) => void;
    setChecked: (state: boolean) => void;
    setShowPricingForm: (state: boolean) => void;
}

const useCatalogueState = create<ICatalogueState>((set) => ({
    activeProducts: true,
    activeProduct: null,
    checked: false,
    listOfCheckedProducts: [],
    showPricingForm: false,
    setActiveProducts: (activeProducts) => set({ activeProducts }),
    setListOfCheckedProducts: (listOfCheckedProducts) => set({ listOfCheckedProducts }),
    setChecked: (checked) => set({ checked }),
    setActiveProduct: (activeProduct) => set({ activeProduct }),
    setShowPricingForm: (showPricingForm) => set({ showPricingForm }),
}));

export default useCatalogueState;
